<template>
    <div class="ai-profile">
        <h4>{{ $t("ai_offer.profile_intro") }}</h4>

        <div class="summary">
            <div class="row-item">
                <span class="k">{{ $t("ai_offer.field_areas") }}</span>
                <span class="v">{{ odboryText || "—" }}</span>
            </div>
            <div class="row-item">
                <span class="k">{{ $t("ai_offer.field_services") }}</span>
                <span class="v">{{ profile.typicke_sluzby || "—" }}</span>
            </div>
            <div class="row-item">
                <span class="k">{{ $t("ai_offer.field_rate", { currency: currency.symbol }) }}</span>
                <span class="v">{{ profile.hodinova_sadzba || "—" }}</span>
            </div>
            <div class="row-item">
                <span class="k">{{ $t("ai_offer.field_style") }}</span>
                <span class="v">{{ stylLabel }}</span>
            </div>
        </div>

        <div class="ulozit" @click="openModal">{{ $t("ai_offer.profile_edit") }}</div>
    </div>
</template>

<script>
import { EventBus } from "../../../offer/components/EventBus.js";

const STYL_KLUCE = {
    elegantna: "eleg",
    minimalisticka: "min",
    detailna: "det",
    technicka: "tech",
};

export default {
    name: "AiProfileSettings",
    data() {
        return {
            profile: {},
            currency: { code: "EUR", symbol: "€" },
        };
    },
    computed: {
        odboryText() {
            return (this.profile.odbory || [])
                .map((slug) =>
                    slug === "ine" && this.profile.odbor_iny ? this.profile.odbor_iny : this.$t("ai_offer.area_" + slug)
                )
                .join(", ");
        },
        stylLabel() {
            const kluc = STYL_KLUCE[this.profile.styl];
            return kluc ? this.$t("ai_offer.modal_style_" + kluc) : "—";
        },
    },
    mounted() {
        this.load();
        EventBus.$on("ai-profile-saved", this.load);
    },
    beforeDestroy() {
        EventBus.$off("ai-profile-saved", this.load);
    },
    methods: {
        load() {
            axios
                .get("/api/ai/profile")
                .then((res) => {
                    this.profile = res.data.profile || {};
                    this.currency = res.data.currency || this.currency;
                })
                .catch(() => {});
        },
        // Profil sa upravuje v tom istom krokovom modale ako pri generovani.
        openModal() {
            EventBus.$emit("open-ai-offer-modal", 1);
        },
    },
};
</script>

<style lang="scss" scoped>
h4 {
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 21px;
    color: #9598a7;
    margin-bottom: 18px;
}
.summary {
    width: 430px;
    max-width: 100%;
    margin: 0 auto;
    border: 1px solid #dde3e8;
    border-radius: 10px;
    overflow: hidden;
    background: #fff;
    .row-item {
        display: flex;
        justify-content: space-between;
        gap: 14px;
        padding: 11px 14px;
        border-top: 1px solid #ecf1f6;
        font-family: Roboto;
        font-size: 13px;
        &:first-child {
            border-top: 0;
        }
        .k {
            color: #9598a7;
            flex-shrink: 0;
        }
        .v {
            color: #212541;
            font-weight: 600;
            text-align: right;
            word-break: break-word;
        }
    }
}
.ulozit {
    width: 430px;
    height: 55px;
    @media only screen and (max-width: 600px) {
        width: 95%;
    }
    margin: 20px auto 0 auto;
    background: #2ed8b6;
    border-radius: 4px;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    color: #ffffff;
    cursor: pointer;
    transition: 0.5s all;
    &:hover {
        background: #23caa9;
    }
}
</style>
